module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jtsiW"))).then(() => parcelRequire('hEqeo'));